import React from 'react';
import { useObservable } from '@logz-pkg/observable';
import { Tooltip } from '@logz-ui/styleguide';
import { OrionIqButton } from '@artemis-ui/orion-chat';
import { orionChatStateService } from './orion-chat.state.service';
import { useOrionChatTriggerState } from './use-orion-chat-gates.hook';
import { ArtemisThemeBoundary } from './ArtemisThemeBoundary';

export const OrionIqTrigger: React.FC = () => {
  const { isAllowedPage, tooltip } = useOrionChatTriggerState();
  const isOpen = useObservable(orionChatStateService.isDrawerOpen) ?? false;
  const status = useObservable(orionChatStateService.status) ?? 'idle';

  const handleClick = (): void => {
    if (!isAllowedPage) return;

    orionChatStateService.toggleDrawer(!isOpen);
  };

  return (
    <ArtemisThemeBoundary>
      <Tooltip title={tooltip} disableEvents={!tooltip}>
        <OrionIqButton
          isSelected={isOpen}
          isProcessing={status !== 'idle'}
          disabled={!isAllowedPage}
          onClick={handleClick}
          aria-label={'OrionIQ chat'}
        />
      </Tooltip>
    </ArtemisThemeBoundary>
  );
};
